import anime from 'animejs';
import Component from 'navigation/component/Component';
import mqStore from 'store/mqStore';
export default class CartReinsurance extends Component {
    previousPrevious = 0;
    previous = 0;
    _current = 1;
    next = 2;
    width = 0;
    itemWidths = [];
    get current() {
        return this._current;
    }
    set current(value) {
        this.previousPrevious = this.previous;
        this.previous = this._current;
        this._current = value % this.refs.reinsuranceItem.length;
        this.next = (value + 1) % this.refs.reinsuranceItem.length;
    }
    initialized() {
        super.initialized();
        this.resize();
        const offset = mqStore.tabletPortrait.get() ? 0 : this.width * 0.1;
        this.refs.reinsuranceItem[0].classList.add('active');
        this.refs.reinsuranceItem[0].style.transform = `translateX(${-this.itemWidths[0] + offset}px)`;
        this.refs.reinsuranceItem[1].classList.add('active');
        this.refs.reinsuranceItem[1].style.transform = `translateX(${0.5 * this.width - this.itemWidths[1] / 2}px)`;
        this.refs.reinsuranceItem[2].classList.add('active');
        this.refs.reinsuranceItem[2].style.transform = `translateX(${this.width - offset}px)`;
        setInterval(() => {
            this.update();
        }, 2500);
    }
    getModulesMap() {
        return {};
    }
    resize() {
        super.resize();
        this.width = this.el.getBoundingClientRect().width;
        this.itemWidths = this.refs.reinsuranceItem.map((item) => {
            return item.getBoundingClientRect().width;
        });
    }
    update() {
        this.current++;
        const offset = mqStore.tabletPortrait.get() ? 0 : this.width * 0.1;
        this.refs.reinsuranceItem[this.previous].classList.add('active');
        this.refs.reinsuranceItem[this.current].classList.add('active');
        this.refs.reinsuranceItem[this.next].classList.add('active');
        anime({
            targets: this.refs.reinsuranceItem[this.previousPrevious],
            translateX: -this.width,
            duration: 1000,
            easing: 'easeInOutQuad',
            complete: (anim) => {
                this.refs.reinsuranceItem[this.previousPrevious].classList.remove('active');
            }
        });
        anime({
            targets: this.refs.reinsuranceItem[this.previous],
            translateX: -this.itemWidths[this.previous] + offset,
            duration: 1000,
            easing: 'easeInOutQuad'
        });
        anime({
            targets: this.refs.reinsuranceItem[this.current],
            translateX: 0.5 * this.width - this.itemWidths[this.current] / 2,
            duration: 1000,
            easing: 'easeInOutQuad'
        });
        const dist = this.width - offset + (0.5 * this.width - this.itemWidths[this.current] / 2);
        anime({
            targets: this.refs.reinsuranceItem[this.next],
            translateX: [dist, this.width - offset],
            duration: 1000,
            easing: 'easeInOutQuad'
        });
    }
}
